import React, { createContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';

const getThemeType = Cookies.get('themeTypeCookie')
	? Cookies.get('themeTypeCookie')
	: 'dark';
const getThemeName = Cookies.get('themeNameCookie')
	? Cookies.get('themeNameCookie')
	: 'ocean';

const MyThemeContext = createContext({
	themeType: getThemeType,
	themeName: getThemeName
});
let expiration_date = new Date();
expiration_date.setFullYear(expiration_date.getFullYear() + 1);

export const MyThemeProvider = ({ children }) => {
	const [themeType, setThemeType] = useState(getThemeType);
	const [themeName, setThemeName] = useState(getThemeName);

	useEffect(() => {
		let themeTypeCookie = Cookies.get('themeTypeCookie');
		let themeNameCookie = Cookies.get('themeTypeCookie');
		if (!themeTypeCookie && !themeNameCookie) {
			Cookies.set('themeTypeCookie', 'dark', {
				expires: expiration_date,
				sameSite: 'Lax'
			});
			Cookies.set('themeNameCookie', 'ocean', {
				expires: expiration_date,
				sameSite: 'Lax'
			});
			setThemeType('dark');
			setThemeName('ocean');
		} else {
			Cookies.set('themeTypeCookie', themeType, {
				expires: expiration_date
			});
			Cookies.set('themeNameCookie', themeName, {
				expires: expiration_date
			});
		}
	}, [themeType, themeName]);
	return (
		<MyThemeContext.Provider
			value={{
				themeType,
				themeName,
				setMyThemeType: type => setThemeType(type),
				setMyThemeName: name => setThemeName(name)
			}}
		>
			{children}
		</MyThemeContext.Provider>
	);
};

export default MyThemeContext;
